module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-rec-details/land-rec-details.component.css
// module id = ./src/app/landprocurement/land-rec-details/land-rec-details.component.css
// module chunks = main